import React from 'react'
import get from 'lodash/get'
import MenuItem from '@material-ui/core/MenuItem'

import { Icon, ProfileAvatar } from 'src/chrome'

import { MinimalSponsorFragment } from 'src/graphql'

const menuItemStyles = {
  selected: { backgroundColor: 'rgba(0,0,0,.04)' },
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '5px 0',
    flex: 1,
  },
  avatar: {
    marginRight: 10,
    color: '#FFF',
    fontWeight: 700,
  },
  name: {
    textOverflow: 'ellipsis',
    fontWeight: 700,
  },
  close: { marginLeft: 'auto' },
}

type Props = {
  sponsor: Partial<MinimalSponsorFragment>
  onClear?: () => void
}

const SponsorBadge: React.FC<Props> = props => {
  const { sponsor, onClear } = props

  return (
    <div>
      <h6 style={{ margin: '10px 0' }}>Your Sponsor</h6>
      <MenuItem style={menuItemStyles.selected}>
        <div style={menuItemStyles.container}>
          <ProfileAvatar
            avatarWrapperStyles={{
              width: 'initial',
            }}
            style={menuItemStyles.avatar}
            image={get(sponsor, 'storefront.mugshot.url', '')}
            name={`${sponsor.firstName} ${sponsor.lastName}`}
            size={50}
          />
          <span
            id={'sponsor_name'}
            style={menuItemStyles.name}
          >{`${sponsor.firstName} ${sponsor.lastName}`}</span>
          {onClear ? (
            <div style={menuItemStyles.close} onClick={() => onClear()}>
              <Icon icon={'CLOSE'} color={'#000000'} />
            </div>
          ) : null}
        </div>
      </MenuItem>
    </div>
  )
}

export default SponsorBadge
